import React, { forwardRef, ReactElement } from 'react'
import { DelayEditor } from './delay-editor'
import { SendNotificationEditor } from './send-notification-editor'
import {
    isDelayJourneyNode,
    isActionJourneyNode,
    isSendActionNode,
    isVariantSplitJourneyNode,
    isConditionalStepJourneyNode,
    JourneyNode,
    NodeEditorRef,
} from '../types/journey-nodes'
import { JourneyActionType } from '@pushly/models/lib/enums/journeys/journey-action-type'
import { SendRecommendedNotificationEditor } from './send-recommended-notification-editor/send-recommended-notification-editor'
import { SplitStepEditor } from './split-step-editor/split-step-editor'
import { ConditionStepEditor } from './condition-step-editor/condition-step-editor'

type NodeEditorProps = {
    node: JourneyNode
}

export const NodeEditor = forwardRef<NodeEditorRef, NodeEditorProps>(({ node }, ref) => {
    let editor: ReactElement | null

    if (!node) {
        return null
    }

    if (isDelayJourneyNode(node)) {
        editor = <DelayEditor node={node} ref={ref} />
    } else if (
        isActionJourneyNode(node)
        && !isSendActionNode(node, JourneyActionType.SEND_RECOMMENDED_NOTIFICATION)
    ) {
        editor = <SendNotificationEditor node={node} ref={ref} />
    } else if (isSendActionNode(node, JourneyActionType.SEND_RECOMMENDED_NOTIFICATION)) {
        editor = <SendRecommendedNotificationEditor node={node} ref={ref} />
    } else if (isVariantSplitJourneyNode(node)) {
        editor = <SplitStepEditor node={node} ref={ref} />
    } else if (isConditionalStepJourneyNode(node)) {
        editor = <ConditionStepEditor node={node} ref={ref} />
    } else {
        editor = null
    }

    return editor
})
